module.exports = __webpack_public_path__ + "media/images/linkedin-245c809f6a20a0e7837b9cefe106c21c.png";